var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{staticClass:"content",attrs:{"size":80,"width":8,"indeterminate":"","color":"primary"}})
}
var staticRenderFns = []

export { render, staticRenderFns }